import { http, HttpResponse } from 'msw'
import { tenantConfigFixtures } from 'src/fixtures/tenant-config'

const updateConfigurations = (basePath: string, configurations: KeyValuePair[]) => {
  const fixture = tenantConfigFixtures[basePath]
  if (!fixture) return

  for (const update of configurations) {
    const existing = fixture.configurations.find((config) => config.key === update.key)
    if (existing) {
      existing.value = update.value
    } else {
      fixture.configurations.push({ key: update.key, value: update.value })
    }
  }
}

export const handlers = () =>
  Object.keys(tenantConfigFixtures).flatMap((basePath) => [
    http.post(
      `${basePath}/GetConfigurables`,
      () =>
        new HttpResponse(
          JSON.stringify({ configurables: tenantConfigFixtures[basePath].configurables })
        )
    ),
    http.post(
      `${basePath}/FindOrCreateTenantConfiguration`,
      () =>
        new HttpResponse(
          JSON.stringify({ configurations: tenantConfigFixtures[basePath].configurations })
        )
    ),
    http.post(`${basePath}/UpdateTenantConfiguration`, async ({ request }) => {
      const body = (await request.json()) as { configurations?: KeyValuePair[] }
      const { configurations } = body
      updateConfigurations(basePath, configurations ?? [])
      return new HttpResponse(
        JSON.stringify({ configurations: tenantConfigFixtures[basePath].configurations })
      )
    }),
  ])
